export default "__VITE_ASSET__Dpay2hUA__"